import React, { useState } from "react";
import loadable from "@loadable/component";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../contants/Endpoints";
import usePaginationState from "../../customHooks/usePaginationHook";
import { useSearchParams } from "react-router-dom";
import moment from "moment";
const SalesLedgerComponent = loadable(
  () => import("../../components/SalesLedger")
);

type Props = {};

const SalesLedger = (props: Props) => {
  const { pageSize, setPageSize, offset, setOffset } = usePaginationState();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const dateStart = startDate
    ? moment(startDate).startOf("day").format("yyyy-MM-DDTHH:mm:ss")
    : null;
  const dateEnd = endDate
    ? moment(endDate).endOf("day").format("yyyy-MM-DDTHH:mm:ss")
    : null;

  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get("search") || "";

  const { data: salesLedgerData, isPending: salesLedgerLoading } = useGetHook({
    queryKey: [
      `salesledger-${pageSize}-${offset}-${searchQuery}-${dateStart}- ${dateEnd}`,
    ],
    url: `${APIS.INVOICE}`,
    params: {
      limit: pageSize,
      offset: offset,
      ...(searchQuery && { search: searchQuery }),
      ...(dateStart &&
        dateEnd && { created__range: `${dateStart}, ${dateEnd}` }),
    },
  });

  return (
    <>
      <SalesLedgerComponent
        salesLedgerData={salesLedgerData}
        salesLedgerLoading={salesLedgerLoading}
        pageSize={pageSize}
        setPageSize={setPageSize}
        offset={offset}
        setOffset={setOffset}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />
    </>
  );
};

export default SalesLedger;
